module.exports = __webpack_public_path__ + "static/media/Golos_Text_Regular.bd998ba8.woff2";